import React, { memo, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { CTX_STATE, disCount, specialNavigate, countdown } from "../common";
import "swiper/scss";
import "swiper/scss/navigation";
import steam from "./styles/scss/img/latest_list/1.png";
import epic from "./styles/scss/img/latest_list/5.png";
import origin from "./styles/scss/img/latest_list/2.png";
import uplay from "./styles/scss/img/latest_list/4.png";
import blizzard from "./styles/scss/img/latest_list/6.png";
import cube from "./styles/scss/img/latest_list/7.png";

const iconObj = {
	1: steam,
	5: epic,
	2: origin,
	4: uplay,
	6: blizzard,
	7: cube,
};

const wjyzIconObj = {
	steam,
	epic,
	origin,
	uplay,
	blizzard,
	cube,
};

function App(props) {
	const { list = [], from } = props;
	const isWjyz = from === "wjyz" ? true : false;
	const navigate = useNavigate();
	const _state = useContext(CTX_STATE);

	//网吧版兼容
	const isNetbar = window.mbQuery?.appInfo?.type === "netbar";

	return (
		<div className="content">
			<Swiper
				modules={[Navigation]}
				slidesPerView={3}
				spaceBetween={19}
				navigation={{
					prevEl: ".latest-prev",
					nextEl: ".latest-next",
				}}
			>
				{list.map((ele, index) => {
					const list_img = isWjyz
						? `url(https://cdn-wjyz.wanjiayizhan.com${encodeURI(ele.img_url)})`
						: `url(${ele.list_img})`;
					const platform = isWjyz
						? wjyzIconObj[ele.pro_platform]
						: iconObj[ele.platform];
					const discount = isWjyz
						? disCount(ele.price, ele.special_price)
						: disCount(ele.source_price, ele.group_vip_price);
					const product_name = isWjyz ? ele.name : ele.product_name;
					const origin_price = isWjyz ? ele.price / 100 : ele.source_price;
					const price = isWjyz ? ele.special_price / 100 : ele.group_vip_price;
					const tag = isWjyz
						? [
								{
									name: ele.pro_platform,
								},
								{
									name: ele.pro_area,
								},
								{
									name: ele.pro_version,
								},
						  ]
						: ele.tag.slice(0, 3);
					const canFreePlay = countdown(ele.created_at) <= 0;

					return (
						<SwiperSlide key={index}>
							<div
								className="left"
								style={{
									backgroundImage: list_img,
								}}
								onClick={() => {
									specialNavigate(
										"/Goods",
										_state.token,
										navigate,
										isWjyz,
										ele
									);
								}}
							>
								{platform && (
									<div>
										<img src={platform} alt="platform" />
									</div>
								)}
							</div>
							<div className="right">
								<div title={product_name}>{product_name}</div>
								<div>
									{!!discount && (
										<>
											<div className="discount">-{discount}%</div>
											<div className="origin-price">￥{origin_price}</div>
										</>
									)}
									<div className="price">
										{!isWjyz && canFreePlay && isNetbar ? "免费" : `￥${price}`}
									</div>
								</div>
								<div>
									{(tag || []).map((ele, index) => {
										return <div key={index}>{ele.name}</div>;
									})}
								</div>
							</div>
							{!isWjyz && (
								<div className="time">
									<div></div>
									<div>{ele.publish_date || "暂无信息"}</div>
								</div>
							)}
						</SwiperSlide>
					);
				})}
			</Swiper>

			<button type="button" className="latest-prev">
				&lt;
			</button>
			<button type="button" className="latest-next">
				&gt;
			</button>

			{!isWjyz && <div className="latest-pagination"></div>}
		</div>
	);
}

export default memo(App);
